// JavaScript files are compiled and minified during the build process to the assets/built folder.

// Import CSS
import "../css/index.css";

// Import JS
import menuOpen from "./menuOpen";
import infiniteScroll from "./infiniteScroll";
import themeToggle from "./themeToggle";

// Initialize modules
themeToggle();
menuOpen();
infiniteScroll();